import { useState } from 'react';
import { useField } from 'informed';
import { CodeInput, RadioGroupInput } from 'components/common/form/common';
import { RichTextEditorInput } from 'components/common/richTextEditor';

interface Props {
  id: string;
  initialValue?: string;
  field: string;
  placeholder?: string;
  rows?: number;
}

const RichTextOrHtml = (props: Props) => {
  const [activeType, setActiveType] = useState<'html' | 'richtext'>('richtext');

  const { fieldApi, fieldState, render, userProps } = useField({
    ...props,
    ...{ activeType }
  });

  const updateHTML = (html: string) => {
    fieldApi.setValue(html);
    if (userProps.onValueChange) userProps.onValueChange(html);
  };

  const Wrapper = activeType === 'richtext' ? RichTextEditorInput : CodeInput;

  const onChange =
    activeType === 'richtext'
      ? { onChange: updateHTML }
      : { onValueChange: updateHTML };

  return render(
    <div className="wrapper">
      <Wrapper
        {...onChange}
        placeholder={userProps.placeholder}
        rows={userProps.rows}
        value={fieldState.value || userProps.initialValue || ''}
      />

      <div className="footer">
        <RadioGroupInput
          inline={true}
          onChange={setActiveType}
          options={[
            {
              id: `rich-text-or-code-richtext-${userProps.id}`,
              label: 'Rich text',
              value: 'richtext'
            },
            {
              id: `rich-text-or-code-html-${userProps.id}`,
              label: 'Html',
              value: 'html'
            }
          ]}
          value={activeType}
        />
      </div>

      <style jsx>{`
        .footer {
          display: flex;
          justify-content: flex-end;
          padding: 2px 5px;
        }
      `}</style>
    </div>
  );
};

export default RichTextOrHtml;
